import React from "react";
import ReactDOM from "react-dom/client";
import { toast } from "sonner";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA installability + update notifications
// (production only). Skip on the OAuth callback page — registering the SW
// mid-flow can cause the page to re-render and re-submit a single-use
// Google auth code.
if (
  "serviceWorker" in navigator &&
  process.env.NODE_ENV === "production" &&
  !window.location.pathname.startsWith("/auth/")
) {
  window.addEventListener("load", () => {
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });

    const notifyUpdate = (worker) => {
      toast("Nueva versión disponible", {
        description: "Actualizá para ver los últimos cambios de la app.",
        duration: Infinity,
        action: {
          label: "Actualizar",
          onClick: () => worker.postMessage({ type: "SKIP_WAITING" }),
        },
      });
    };

    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Force an update check now, every 30 min, and when the tab regains focus
        reg.update();
        setInterval(() => reg.update(), 30 * 60 * 1000);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") reg.update();
        });

        // A new SW is already waiting (page loaded with old SW active)
        if (reg.waiting && navigator.serviceWorker.controller) {
          notifyUpdate(reg.waiting);
        }
        // Detect future updates as they install
        reg.addEventListener("updatefound", () => {
          const worker = reg.installing;
          if (!worker) return;
          worker.addEventListener("statechange", () => {
            if (worker.state === "installed" && navigator.serviceWorker.controller) {
              notifyUpdate(worker);
            }
          });
        });
      })
      .catch(() => {});
  });
}
